var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.actualDefinition.name))]},proxy:true}])},[_c('svg',{ref:"chartRender",staticStyle:{"background-color":"white","width":"100%","height":"100vh"}})])}
var staticRenderFns = []

export { render, staticRenderFns }